<div *ngIf="!isNew && initialized && !enableCustomiseMessaging" style="min-height: calc(100vh - 60px);"
  class="d-flex align-items-center justify-content-center">
  <div class="LearnModulesBox">
    <div class="Learns_Iocns">
      <img src="assets/images/check-icon.png" alt="">
    </div>
    <p class="textPara montserrat-semibold font-22 navColor80 mg-b10 pre-wrap">Hey {{ user?.firstName?.split(' ')[0]  | titlecase}}!</p>
    <p class="textPara montserrat-regular navColor80 mg-b20 pre-wrap" *ngIf="!course.isNewEvaluation">Your responses are a critical starting point of the learning journey.<br>The Primer helps us understand your current level of Skill, Effort and Confidence.</p>
    <!-- <p class="textPara montserrat-regular navColor80 mg-b20 pre-wrap" *ngIf="course.isNewEvaluation">Thank you for letting us have a glimpse into what you practice and value in your daily life.<br>The Primer was designed for self-reflection and does not contribute to your 
      <span class="has-tooltip has-tooltip--mobilevisible h-score">
        <strong>H_Score</strong>
        <span class="custom-tooltip custom-tooltip--white custom-tooltip__top white-space-wrap no-border">
            H_Score is a overall course score. Your H_Score will be calculated by adding all the points you will earn in Practice Exercises and Touchstones
        </span>
      </span>
      <br>You are not graded on this but it’s a crucial part of the learning journey.
    </p> -->
    <p class="textPara montserrat-regular navColor80 mg-b20 pre-wrap" *ngIf="course.isNewEvaluation">The Primer was designed for self-reflection.<br>Thank you for letting us have a glimpse into what you practice and value in your daily life.<br>The Primer does not contribute to your overall Course Score but is a crucial part of the learning journey.<br>Let’s jump right into the course now!
    </p>
    <!-- <p class="font-15 montserrat-medium navColor mg-b20 pre-wrap" *ngIf="course.isNewEvaluation">Let’s get you started!</p>
    <div class="viewScores viewScores--small text-left" *ngIf="course.isNewEvaluation">
        <p class="montserrat-medium navColor font-13 lh20 mg-b20">In this course you will learn to:</p>
        <ul class="listCourseModule">
            <li *ngFor="let blo of course.courseBlo">{{blo.title}}</li>
        </ul>
    </div> -->
    <button (click)="next()" type="button" class="btn btn-primary long-btn30"><span>Begin Learning</span></button>
  </div>
</div>

<div *ngIf="isNew && initialized" class="LearnModulesOverlay">
  <div class="new-question-completed">
    <div class="new-question__container text-center">
      <!-- <h4 class="mb-3 new-question-completed__title">{{exerciseDetails.moduleName}}</h4> -->
      <h3 class="mb-4 new-question-completed__subtitle">{{exerciseDetails.title}}</h3>
      <!-- <h3 class="mb-4 new-question-completed__subtitle">Hey {{user.name}}, Thanks for completing that :)</h3> -->
      <p class="mb-5 new-question-completed__desc">Hey {{user?.name}},<br>
        Thank you for letting us have a glimpse into what you value and practice in your daily life. Based on your
        responses, we have gathered some personalized insights.
      </p>
  
      <div class="p-3 p-md-5 row mb-5 mx-2 mx-lg-5">
        <div class="col-xl-5 mb-4 text-left">
          <h4 class="montserrat-semibold font-18 mb-4">Your performance</h4>
          <div class="performance-graph">
            <div class="performance-graph__pillar  has-tooltip">
              <span class="performance-graph__xtitle">Skill</span>
              <span class="custom-tooltip custom-tooltip__top white-space-wrap custom-tooltip__large">An ability we gain
                through practice and training.</span>
              <span style.height="{{xData.SKILL + '%'}}" class="performance-graph__score"></span>
            </div>
            <div class="performance-graph__pillar has-tooltip">
              <span class="performance-graph__xtitle">Effort</span>
              <span class="custom-tooltip custom-tooltip__top white-space-wrap custom-tooltip__large">A determined attempt
                towards a particular goal.</span>
              <span style.height="{{xData.EFFORT + '%'}}" class="performance-graph__score"></span>
            </div>
            <div class="performance-graph__pillar has-tooltip">
              <span class="performance-graph__xtitle">Confidence</span>
              <span class="custom-tooltip custom-tooltip__top white-space-wrap custom-tooltip__large">The degree to which
                you think your actions will achieve positive results.</span>
              <span style.height="{{xData.CONFIDENCE + '%'}}" class="performance-graph__score"></span>
            </div>
            <span class="parameter one">High</span>
            <span class="parameter two">Medium</span>
            <span class="parameter three">Low</span>
          </div>
        </div>
        <div class="col-xl-7 d-flex align-items-center">
          <div class="p-4 p-md-5 light-bg text-left navColor">
            <h4 class="montserrat-semibold font-18 mb-4" *ngIf="newInsights.message1">{{newInsights.message1}}</h4>
            <ul class="pl-4 font-14 lh-30">
              <li class="mb-3" *ngIf="newInsights.strength.length">{{newInsights.thresholdAchieved}}</li>
              <li class="mb-3" *ngIf="newInsights.growthArea.length">{{newInsights.thresholdNotAchieved}}</li>
              <li class="mb-3" *ngIf="newInsights.message2">{{newInsights.message2}}</li>
            </ul>
          </div>
        </div>
      </div>
      <h4 class="mb-5 montserrat-semibold">Improve with the help of...</h4>
      <div class="info--item-container mg-b30">
        <div class="info--item info--item--2">
          <h3 class="info--item--title--2 heading24 mg-b20 primaryColor">{{count.videos}}</h3>
          <p class="info--item--para"><strong>Videos</strong></p>
          <p class="info--item--para font-14">from distinguished faculty</p>
        </div>
        <div class="info--item info--item--2">
          <h3 class="info--item--title--2 heading24 mg-b20 primaryColor">{{attemptedExercise.numberOfPracticeExercise}}
          </h3>
          <p class="info--item--para"><strong>Practice Exercises</strong></p>
          <p class="info--item--para font-14">to boost knowledge retention</p>
        </div>
        <div class="info--item info--item--2">
          <h3 class="info--item--title--2 heading24 mg-b20 primaryColor">{{attemptedExercise.numberOfTouchStoneExercise}}
          </h3>
          <p class="info--item--para"><strong>Assessments</strong></p>
          <p class="info--item--para font-14">to gain personlized insights</p>
        </div>
      </div>
  
      <div class="text-center p-4">
        <button class="btn btn-primary long-btn30 long-btn50" (click)="next()" type="button"><span>PROCEED</span></button>
      </div>
    </div>
  </div>  
</div>

<div *ngIf="!isNew && initialized && enableCustomiseMessaging" style="min-height: calc(100vh - 60px);"
  class="d-flex align-items-center justify-content-center">
  <div class="LearnModulesBox">
    <div class="Learns_Iocns">
      <img src="assets/images/check-icon.png" alt="">
    </div>
    <p class="textPara montserrat-semibold font-22 navColor80 mg-b10 pre-wrap">Hey {{ user?.firstName?.split(' ')[0]  | titlecase}}!</p>
    <p [froalaView]="exerciseData?.endScreenMessaging" class="textPara montserrat-regular navColor80 mg-b20 pre-wrap" *ngIf="!course.isNewEvaluation"></p>
    <!-- <p class="textPara montserrat-regular navColor80 mg-b20 pre-wrap" *ngIf="course.isNewEvaluation">Thank you for letting us have a glimpse into what you practice and value in your daily life.<br>The Primer was designed for self-reflection and does not contribute to your 
      <span class="has-tooltip has-tooltip--mobilevisible h-score">
        <strong>H_Score</strong>
        <span class="custom-tooltip custom-tooltip--white custom-tooltip__top white-space-wrap no-border">
            H_Score is a overall course score. Your H_Score will be calculated by adding all the points you will earn in Practice Exercises and Touchstones
        </span>
      </span>
      <br>You are not graded on this but it’s a crucial part of the learning journey.
    </p> -->
    <p [froalaView]="exerciseData?.endScreenMessaging" class="textPara montserrat-regular navColor80 mg-b20 pre-wrap" *ngIf="course.isNewEvaluation">
    </p>
    <!-- <p class="font-15 montserrat-medium navColor mg-b20 pre-wrap" *ngIf="course.isNewEvaluation">Let’s get you started!</p>
    <div class="viewScores viewScores--small text-left" *ngIf="course.isNewEvaluation">
        <p class="montserrat-medium navColor font-13 lh20 mg-b20">In this course you will learn to:</p>
        <ul class="listCourseModule">
            <li *ngFor="let blo of course.courseBlo">{{blo.title}}</li>
        </ul>
    </div> -->
    <button (click)="next()" type="button" class="btn btn-primary long-btn30"><span>{{exerciseData?.endCtaButton}}</span></button>
  </div>
</div>
